// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pageLinks":"_3sk-LZ","link":"Y1r-w0","linkActive":"_2WCX67"};